import { ColTypeDef } from 'ag-grid-community';
import { technicalColumnDefinition } from 'components/shared/Blotter/Grid/blotter.model';
import { IBlotterQuoteItem } from 'models/IBlotterItem';

export const defaultMasterDetailWidth = 65;

export function createMasterDetailTechnicalColumn<TItem = IBlotterQuoteItem>(
  customProps: Partial<ColTypeDef<TItem>> = {},
  width: number = defaultMasterDetailWidth,
) {
  return {
    ...technicalColumnDefinition,
    valueFormatter: () => '',
    width: width,
    minWidth: width,
    cellRenderer: 'agGroupCellRenderer',
    ...customProps,
  } as ColTypeDef<TItem>;
}
